import type { PriceValidation, SizeValidation } from "./ExchangeBettingPotential.types";
import type { ExchangeSide, URN } from "../../../types";

export const BETSLIP__EXC_SP_CHANGED = "BETSLIP/EXC_SP_CHANGED";

export type ExchangeSpChangedAction = {
  type: typeof BETSLIP__EXC_SP_CHANGED;
  payload: { isActive: boolean };
};

export const BETTING__REMOVE_ALL_POTENTIAL_BETS_ACTION = "BETTING/REMOVE_ALL_POTENTIAL_BETS_ACTION";

export type RemoveAllPotentialBetsAction = {
  type: typeof BETTING__REMOVE_ALL_POTENTIAL_BETS_ACTION;
};

export const BETTING__UPDATE_POTENTIAL_BET_ACTION = "BETTING/UPDATE_POTENTIAL_BET_ACTION";

export type UpdatePotentialBetAction = {
  type: typeof BETTING__UPDATE_POTENTIAL_BET_ACTION;
  payload: {
    runner: URN;
    price?: number;
    size?: number;
    side: ExchangeSide;
  };
};

export const BETTING__NUDGE_UP_POTENTIAL_BET_ACTION = "BETTING/NUDGE_UP_POTENTIAL_BET_ACTION";

export type NudgeUpPotentialBetAction = {
  type: typeof BETTING__NUDGE_UP_POTENTIAL_BET_ACTION;
  payload: {
    runner: URN;
    side: ExchangeSide;
    price?: number;
    size?: number;
    input: "size" | "price";
  };
};

export const BETTING__NUDGE_DOWN_POTENTIAL_BET_ACTION = "BETTING/NUDGE_DOWN_POTENTIAL_BET_ACTION";

export type NudgeDownPotentialBetAction = {
  type: typeof BETTING__NUDGE_DOWN_POTENTIAL_BET_ACTION;
  payload: {
    runner: URN;
    side: ExchangeSide;
    price?: number;
    size?: number;
    input: "size" | "price";
  };
};

export const BETTING__VALID_UPDATE_POTENTIAL_BET_ACTION = "BETTING/VALID_UPDATE_POTENTIAL_BET_ACTION";

export type ValidUpdatePotentialBetAction = {
  type: typeof BETTING__VALID_UPDATE_POTENTIAL_BET_ACTION;
  payload: {
    price?: number;
    size?: number;
    runner: URN;
    side: ExchangeSide;
  };
};

export const BETTING__INVALID_UPDATE_PRICE_POTENTIAL_BET_ACTION = "BETTING/INVALID_UPDATE_PRICE_POTENTIAL_BET_ACTION";

export type InvalidUpdatePricePotentialBetAction = {
  type: typeof BETTING__INVALID_UPDATE_PRICE_POTENTIAL_BET_ACTION;
  payload: {
    price?: number;
    runner: URN;
    side: ExchangeSide;
    error: PriceValidation;
  };
};

export const BETTING__INVALID_UPDATE_SIZE_POTENTIAL_BET_ACTION = "BETTING/INVALID_UPDATE_SIZE_POTENTIAL_BET_ACTION";

export type InvalidUpdateSizePotentialBetAction = {
  type: typeof BETTING__INVALID_UPDATE_SIZE_POTENTIAL_BET_ACTION;
  payload: {
    size?: number;
    runner: URN;
    side: ExchangeSide;
    error: SizeValidation;
  };
};

export const BETTING__EXC_PRICE_AT_PLACEMENT_UPDATE = "BETTING/EXC_PRICE_AT_PLACEMENT_UPDATE";

export type ExchangePriceAtPlacementUpdateAction = {
  type: typeof BETTING__EXC_PRICE_AT_PLACEMENT_UPDATE;
  payload: {
    runner: URN;
    side: ExchangeSide;
    priceAtPlacement: number;
  };
};

export const BETTING__EXC_INCREMENT_SIZE_ACTION = "BETTING/EXC_INCREMENT_SIZE_ACTION";

export type BettingExchangeIncrementSizeAction = {
  type: typeof BETTING__EXC_INCREMENT_SIZE_ACTION;
  payload: {
    runner: URN;
    side: ExchangeSide;
    increment: number;
  };
};
